export const i18nextFallbackLanguages: Record<string, string[]> = {
  'en-US': ['en'],
  'en-SA': ['en'],
  'ar-SA': ['ar', 'en'],
  en: ['en-US'],
  default: ['en'],
}
